import { Internal_CheckPermissions } from '@swivl-mono/helpers';
import { APIScope } from '@swivl-mono/types';
import RolesModel from '../../Models/Roles/Roles.Model';
import AccountModel from '../../Models/Account/AccountModel';

export function useHasPermission(scope?: APIScope, groupId?: number, locationId?: number) {
  const { parentRoles, roles } = RolesModel.useState();
  const { member } = AccountModel.useState((s) => s);

  if (member?.swivlAdmin) {
    return true;
  }
  if (!scope || !member || !roles) {
    return false;
  }
  const has = Internal_CheckPermissions(parentRoles, roles, member.permissions, scope, member.orgId, groupId, locationId);

  return has;
}
